import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import { TalesFaq } from "../../../utils/types/TalesFaq";

export const deleteFaq = createAsyncThunk(
  "faq/delete",
  async (faq: TalesFaq) => {
    try {
      const querySnapshot = await db
        .collection("faq")
        .where("question", "==", faq.question)
        .get();

      return querySnapshot.docs[0].ref.delete();
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Faq non eliminata, ${e.message}`);
    }
  },
);
